import axios from "axios";

export default {
    async getConfig() {
        var response = await axios.get('https://ipapi.co/json/');
        return response.data;
    }
}